import React from 'react';
import { LayoutRoute } from 'components/Layout';
import {
  default as HomePublica,
  default as HomePublicaLayout,
} from 'components/Layout/HomePublica';
import APIndividualResumenContainer from 'containers/AccidentesPersonales/APIndividualResumenContainer';
import RecuperarAPIContainer from 'containers/AccidentesPersonales/RecuperarAPIContainer';
import SeleccionarPlanContainer from 'containers/AccidentesPersonales/SeleccionarPlanContainer';
import SeleccionarTipoContainer from 'containers/AccidentesPersonales/SeleccionarTipoContainer';
import EmisionAseguradosContainer from 'containers/Emision/Asegurados';
import ContainerFormAseguradoHerederos from 'containers/Polizas/ContainerFormAseguradoHerederos';

const AP_ROUTES = [
  <LayoutRoute
    exact={true}
    path="/accidentes-personas/:idCotizacion?"
    layout={HomePublicaLayout}
    component={SeleccionarTipoContainer}
    navBarTab="personas"
    validations={{
      prePolizaPagada: true,
    }}
  />,

  <LayoutRoute
    exact={true}
    path="/accidentes-planes-personas/:idCotizacion"
    layout={HomePublicaLayout}
    component={SeleccionarPlanContainer}
    navBarTab="personas"
    validations={{
      prePolizaPagada: true,
    }}
  />,

  <LayoutRoute
    exact={true}
    path="/accidentes-resumen-personas/:idCotizacion"
    layout={HomePublicaLayout}
    component={APIndividualResumenContainer}
    navBarTab="personas"
    validations={{
      prePolizaPagada: true,
    }}
  />,

  <LayoutRoute
    exact
    path="/recuperar-cotizacion-ap"
    layout={HomePublicaLayout}
    component={RecuperarAPIContainer}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact
    path="/emision-asegurados"
    layout={HomePublica}
    component={EmisionAseguradosContainer}
  />,

  <LayoutRoute
    exact
    path="/agregar-asegurado"
    layout={HomePublicaLayout}
    component={ContainerFormAseguradoHerederos}
  />,
];

export default AP_ROUTES;
